import { db } from '@/config/firebase';

async function getNotificationById(id) {
    let query = db.collection('notifications').doc(id);
    const querySnapshot = await query.get();

    let notificationObj = {};
    querySnapshot.forEach(item => {
        notificationObj = item.data();
        notificationObj.id = item.id;
    });

    return notificationObj;
}

async function setAsViewed(id) {
    let query = db.collection('notifications').doc(id);
    return query.set({ isViewed: true }, { merge: true });
}

async function clearNotification(id) {
    let query = db.collection('notifications').doc(id);
    return query.set({ isDeleted: true }, { merge: true });
}

async function clearNotifications(ids) {
    const batch = db.batch();

    ids.forEach(id => {
        const notificationRef = db.collection('notifications').doc(id);
        batch.set(notificationRef, { isDeleted: true }, { merge: true });
    });

    return batch.commit();
}

function generateQuery(filter) {
    let query = db.collection("notifications");

    if (filter.email && filter.email.length > 0) {
        query = query.where('recipient', '==', filter.email)
    }
    query = query.orderBy("dateSent", "desc");

    return query;
}

async function getNotificationsPage(filter, options = {}) {
    const limit = options.limit || 20;
    const cursor = options.cursor || null;
    let query = generateQuery(filter).limit(limit);

    if (cursor) {
        query = query.startAfter(cursor);
    }

    const snapshot = await query.get();
    const notifications = [];

    snapshot.forEach(doc => {
        let notification = doc.data();
        notification.id = doc.id;

        if (notification.isDeleted !== true) {
            notifications.push(notification);
        }
    });

    return {
        notifications,
        cursor: snapshot.docs.length ? snapshot.docs[snapshot.docs.length - 1] : null,
        hasMore: snapshot.docs.length === limit
    };
}

function getNotificationListener(filter, callback) {
    let query = generateQuery(filter);
    let listener = query.onSnapshot((snapshot) => {
        snapshot.docChanges().forEach((change) => {
            let notification = change.doc.data();
            notification.id = change.doc.id;

            callback(change.type, notification);
        });
    });
    return listener;
}

export default {
    getNotificationById,
    setAsViewed,
    clearNotification,
    clearNotifications,
    getNotificationsPage,
    getNotificationListener
}
